var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyDollarCircleLine = function SvgMoneyDollarCircleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m-3.15-5.4h4.95a.45.45 0 0 0 0-.9h-3.6a2.25 2.25 0 0 1 0-4.5h.9V6.6h1.8v1.8h2.25v1.8H10.7a.45.45 0 0 0 0 .9h3.6a2.25 2.25 0 0 1 0 4.5h-.9v1.8h-1.8v-1.8H9.35z"
  })));
};
export default SvgMoneyDollarCircleLine;